import {CheckboxContext, useCheckboxSelection} from "../Checkbox";
import {Menu, MenuItem} from "@mui/material";
import {useContext, useState} from "react";
import {useTableData} from "../../../../misc/scroller/Table";
import {logisticsTableName} from "./Logistics";
import {useProjectId} from "../ProjectName";
import {InventoryRequest} from "../../../../api/Logistics";
import {ArchiveItemsForm, canArchive} from "./ArchiveItemsForm";

export function BulkArchive(props: {
    type: string;
    anchorEl: HTMLElement | null;
    onOpen(): void;
}) {
    const sel = useCheckboxSelection()
    const setChecked = useContext(CheckboxContext).set;
    const [open, setOpen] = useState(false);
    const project = useProjectId();
    const data = useTableData(logisticsTableName(project, props.type)) as InventoryRequest[]

    const values = data.filter(d => sel.indexOf(d.id) !== -1 && canArchive(d));

    return <>
        <MenuItem disabled={values.length === 0} onClick={() => {
            props.onOpen();
            setOpen(true);
        }}>Archive</MenuItem>

        {open && <Menu open anchorEl={props.anchorEl} onClose={() => setOpen(false)}>
            <ArchiveItemsForm type={props.type} rows={values} onCancel={() => setOpen(false)} onArchived={ids => {
                // un-tick what we just submitted, the archived rows are about to leave the table
                ids.forEach(id => setChecked(id, false));
                setOpen(false);
            }} />
        </Menu>}
    </>
}
